import { Download } from "../../../helpers/download";
import { NotifyHelper } from "../../../helpers/toast";
import { eBienLaiPagingActionsObj } from "../../action-types/bien-lai/IBienLaiPagingActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const bienLaiPagingActions = {
  ...generateActions(eBienLaiPagingActionsObj, "BIEN_LAI_PAGING"),
  ...generateActionForKey(
    eBienLaiPagingActionsObj,
    "BIEN_LAI_PAGING",
    "HUY_ERRR",
    (m: any) => {
      NotifyHelper.Error(m.data);
    }
  ),
  ...generateActionForKey(
    eBienLaiPagingActionsObj,
    "BIEN_LAI_PAGING",
    "HUY_SUCCESS",
    (m: any) => {
      NotifyHelper.Success("Hủy thành công");
    }
  ),
  ...generateActionForKey(
    eBienLaiPagingActionsObj,
    "BIEN_LAI_PAGING",
    "EXPORT_EXCEL_BAO_CAO_SUCCESS",
    (data: any) => {
      Download.Excel(data, "bao_cao_bien_lai.xlsx");
      NotifyHelper.Success("Thành công!");
    }
  ),
  ...generateActionForKey(
    eBienLaiPagingActionsObj,
    "BIEN_LAI_PAGING",
    "EXPORT_EXCEL_BAO_CAO_ERRR",
    (m: any) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eBienLaiPagingActionsObj,
    "BIEN_LAI_PAGING",
    "PRINT_BAO_CAO_SUCCESS",
    (data: any) => {
      NotifyHelper.Success("Thành công!");
    }
  ),
  ...generateActionForKey(
    eBienLaiPagingActionsObj,
    "BIEN_LAI_PAGING",
    "PRINT_BAO_CAO_ERRR",
    (m: any) => {
      NotifyHelper.Error(m);
    }
  ),
};
